"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TEASER_CONTENT_POSITION_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_CONTENT_POSITION_TYPE;
  }
});
Object.defineProperty(exports, "TEASER_IMAGE_POSITION_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_IMAGE_POSITION_TYPE;
  }
});
Object.defineProperty(exports, "TEASER_LOGO_POSITION_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_LOGO_POSITION_TYPE;
  }
});
exports.TEASER_STYLE_TYPE = void 0;
Object.defineProperty(exports, "TEASER_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_TYPE;
  }
});
exports.TeaserEvolution = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Teaser = require("b2b-components/core/components/CMS/Teaser/Teaser");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _SmallTeaser = require("./SmallTeaser");
var _TeaserWithBackground = require("./TeaserWithBackground");
let TEASER_STYLE_TYPE = exports.TEASER_STYLE_TYPE = /*#__PURE__*/function (TEASER_STYLE_TYPE) {
  TEASER_STYLE_TYPE["light"] = "light";
  TEASER_STYLE_TYPE["dark"] = "dark";
  TEASER_STYLE_TYPE["DMKGreen"] = "DMK-Green";
  TEASER_STYLE_TYPE["DMKBlue"] = "DMK-Blue";
  TEASER_STYLE_TYPE["DMKGreyBlue"] = "DMK-GreyBlue";
  TEASER_STYLE_TYPE["DMKWarmGrey"] = "DMK-WarmGrey";
  TEASER_STYLE_TYPE["DMKYellow"] = "DMK-Yellow";
  TEASER_STYLE_TYPE["DMKRose"] = "DMK-Rose";
  TEASER_STYLE_TYPE["DMKRed"] = "DMK-Red";
  TEASER_STYLE_TYPE["DMKViolet"] = "DMK-Violet";
  TEASER_STYLE_TYPE["DMKPetrol"] = "DMK-Petrol";
  TEASER_STYLE_TYPE["DMKEvolution"] = "DMK-Evolution";
  return TEASER_STYLE_TYPE;
}({});
const TeaserEvolution = props => {
  const {
    className,
    onClick,
    url,
    dataAttributes,
    imagePosition = _Teaser.TEASER_IMAGE_POSITION_TYPE.center,
    styleType = TEASER_STYLE_TYPE.light,
    type = _Teaser.TEASER_TYPE.size50,
    contentInnerClassName,
    contentTitleClassName,
    contentTextClassName
  } = props;
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    url && onClick?.(url);
  };
  const imageClassName = (0, _classnames.default)('cds-Teaser-Image', {
    [`cds-Teaser-Image--${(0, _upperCase.upperCaseFirst)(imagePosition)}`]: imagePosition !== _Teaser.TEASER_IMAGE_POSITION_TYPE.center
  });
  const contentInnerClass = (0, _classnames.default)('cds-Teaser-ContentInner', contentInnerClassName);
  const contentTitleClass = (0, _classnames.default)('cds-Teaser-Title', contentTitleClassName);
  const contentTextClass = (0, _classnames.default)('cds-Teaser-Text', contentTextClassName);
  const isBanner = type === _Teaser.TEASER_TYPE.size100 || type === _Teaser.TEASER_TYPE.banner;
  let Component = _SmallTeaser.SmallTeaser;
  if (isBanner) {
    Component = _TeaserWithBackground.TeaserWithBackground;
  }
  const rootClassName = (0, _classnames.default)('cds-Teaser--Light', {
    'cds-Teaser': isBanner,
    'cds-TeaserEvolution': isBanner,
    'cds-SmallTeaser': !isBanner,
    'cds-Teaser--Banner': type === _Teaser.TEASER_TYPE.banner,
    'cds-Teaser--Size100': type === _Teaser.TEASER_TYPE.size100,
    'cds-Teaser--Size66': type === _Teaser.TEASER_TYPE.size66,
    'cds-Teaser--Size50': type === _Teaser.TEASER_TYPE.size50,
    'cds-Teaser--Size33': type === _Teaser.TEASER_TYPE.size33,
    // @ts-ignore
    'cds-Teaser--DMK': _Teaser.STYLES_WITH_BACKGROUND_BANNER.includes(styleType)
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), url ? /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-Teaser-WrapperLink",
    href: url,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    imageClassName: imageClassName,
    contentTextClass: contentTextClass,
    contentTitleClass: contentTitleClass,
    contentInnerClass: contentInnerClass
  }, props))) : /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    imageClassName: imageClassName,
    contentTextClass: contentTextClass,
    contentTitleClass: contentTitleClass,
    contentInnerClass: contentInnerClass
  }, props)));
};
exports.TeaserEvolution = TeaserEvolution;
//# sourceMappingURL=TeaserEvolution.js.map